import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Injectable()
export class ComponentService {
    
    public deleteSource = new Subject<serviceObj>();
    public editSource = new Subject<serviceObj>();
    public addSource = new Subject<serviceObj>();

    deleteAnnounced$ = this.deleteSource.asObservable();
    editAnnounced$ = this.editSource.asObservable();
    addAnnounced$ = this.addSource.asObservable();

    deleteObject(serviceObj) {
        this.deleteSource.next(serviceObj);
    }

    editObject(serviceObj) {
        this.editSource.next(serviceObj);
    }

    addObject(serviceObj) {
        this.addSource.next(serviceObj);
    }
}

export interface serviceObj {
    name: string;
    data: any;
    parent?: string;
    newItem?: boolean;
}
